
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

const Loading = () => {
  const isMobile = useIsMobile();
  
  console.log("Renderizando componente Loading");
  
  return (
    <div className="flex items-center justify-center h-[calc(100vh-80px)]">
      <div className="relative">
        <div className={`${isMobile ? 'h-16 w-16' : 'h-24 w-24'} rounded-full border-t-4 border-b-4 border-primary animate-spin`}></div>
        <div className="absolute top-0 bottom-0 left-0 right-0 flex items-center justify-center">
          <span className={`${isMobile ? 'text-xs' : 'text-sm'} font-medium`}>Cargando...</span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
